export const size = {
  xxsm: '0.5rem',
  xsm: '1rem',
  sm: '1.25rem',
  md: '1.5rem',
  lg: '1.75rem',
  xl: '2rem',
  xxl: '2.5rem',
  xxxl: '2.75rem',
};
